import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Text from 'components/common/Text'
import { Container, Row, Col } from 'react-bootstrap'
import { TagBlock } from './components/TagBlock'

export const WhoPartnerBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<Container style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
				<Row>
					<Col>
						<Text
							size={34}
							style={{
								fontWeight: 'bold',
								textAlign: 'center',
							}}
						>
							Who can become a <span style={{ color: secondaryColor }}>{tenantName}</span> Partner?
						</Text>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={{ span: 8, offset: 2 }}>
						<Text size={18} align={'center'}>
							Any professional who serves homeowners with excellence and passion are ideal{' '}
							<span style={{ color: secondaryColor }}>{tenantName}</span> Partners. Many of our
							Partners are:
						</Text>
					</Col>
				</Row>
			</div>

			<Row>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Real Estate Agents</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Insurance Agents</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Lawyers</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>HOAs</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Property Managers</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>CPAs</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Non-Profits</TagBlock>
				</Col>
				<Col xs={12} sm={6} lg={3} style={{ marginBottom: 10 }}>
					<TagBlock>Tax Agents</TagBlock>
				</Col>
			</Row>
		</Container>
	)
}
